import {
    IgAccTimeFields,
    IgAccountFields,
    IgAudienceCityFields,
    IgAudienceCountryFields,
    IgAudienceGenderAgeFields,
    IgAudienceHourFields,
    IgCommentFields,
    IgMediaFields,
    IgMediaTimeFields,
    IgMetadataAgeFields,
    IgMetadataColorFields,
    IgMetadataEmotionFields,
    IgMetadataFaceDetailFields,
    IgMetadataGenderFields,
    IgMetadataHashtagFields,
    IgMetadataLabelFields,
    IgUser2Fields,
    IgUserFields,
    ProductIgMediaFields,
} from './ig-entities.types';
import {
    IgAccTimeEnum,
    IgAccountEnum,
    IgAudienceCityEnum,
    IgAudienceCountryEnum,
    IgAudienceGenderAgeEnum,
    IgAudienceHourEnum,
    IgCommentEnum,
    IgMediaEnum,
    IgMediaTimeEnum,
    IgMetadataAgeEnum,
    IgMetadataColorEnum,
    IgMetadataEmotionEnum,
    IgMetadataFaceDetailEnum,
    IgMetadataGenderEnum,
    IgMetadataHashtagEnum,
    IgMetadataLabelEnum,
    IgUser2Enum,
    IgUserEnum,
    ProductIgMediaEnum,
} from './ig-entities.enums';
import { ApiEntity } from './api-entity.model';

export const IgAccount = new ApiEntity<IgAccountFields>(IgAccountEnum.prefix, IgAccountEnum.fields);
export const IgAccTime = new ApiEntity<IgAccTimeFields>(IgAccTimeEnum.prefix, IgAccTimeEnum.fields);
export const IgMedia = new ApiEntity<IgMediaFields>(IgMediaEnum.prefix, IgMediaEnum.fields);
export const IgMediaTime = new ApiEntity<IgMediaTimeFields>(
    IgMediaTimeEnum.prefix,
    IgMediaTimeEnum.fields
);
export const IgComment = new ApiEntity<IgCommentFields>(IgCommentEnum.prefix, IgCommentEnum.fields);
export const IgUser = new ApiEntity<IgUserFields>(IgUserEnum.prefix, IgUserEnum.fields);
export const IgUser2 = new ApiEntity<IgUser2Fields>(IgUser2Enum.prefix, IgUser2Enum.fields);
export const IgMetadataLabel = new ApiEntity<IgMetadataLabelFields>(
    IgMetadataLabelEnum.prefix,
    IgMetadataLabelEnum.fields
);
export const IgMetadataEmotion = new ApiEntity<IgMetadataEmotionFields>(
    IgMetadataEmotionEnum.prefix,
    IgMetadataEmotionEnum.fields
);
export const IgMetadataGender = new ApiEntity<IgMetadataGenderFields>(
    IgMetadataGenderEnum.prefix,
    IgMetadataGenderEnum.fields
);
export const IgMetadataAge = new ApiEntity<IgMetadataAgeFields>(
    IgMetadataAgeEnum.prefix,
    IgMetadataAgeEnum.fields
);
export const IgMetadataFaceDetail = new ApiEntity<IgMetadataFaceDetailFields>(
    IgMetadataFaceDetailEnum.prefix,
    IgMetadataFaceDetailEnum.fields
);
export const IgMetadataColor = new ApiEntity<IgMetadataColorFields>(
    IgMetadataColorEnum.prefix,
    IgMetadataColorEnum.fields
);
export const IgMetadataHashtag = new ApiEntity<IgMetadataHashtagFields>(
    IgMetadataHashtagEnum.prefix,
    IgMetadataHashtagEnum.fields
);
export const ProductIgMedia = new ApiEntity<ProductIgMediaFields>(
    ProductIgMediaEnum.prefix,
    ProductIgMediaEnum.fields
);
export const IgAudienceCountry = new ApiEntity<IgAudienceCountryFields>(
    IgAudienceCountryEnum.prefix,
    IgAudienceCountryEnum.fields
);
export const IgAudienceCity = new ApiEntity<IgAudienceCityFields>(
    IgAudienceCityEnum.prefix,
    IgAudienceCityEnum.fields
);
export const IgAudienceGenderAge = new ApiEntity<IgAudienceGenderAgeFields>(
    IgAudienceGenderAgeEnum.prefix,
    IgAudienceGenderAgeEnum.fields
);
export const IgAudienceHour = new ApiEntity<IgAudienceHourFields>(
    IgAudienceHourEnum.prefix,
    IgAudienceHourEnum.fields
);
